import { createSlice } from '@reduxjs/toolkit';
import { resetToInitialState } from '~/reducers/common-actions';

export const selectedDrawerCardIdSlice = createSlice({
    name: 'selectedDrawerCardId',
    initialState: null,
    reducers: {
        setSelectedDrawerCardId: (state, action) => {
            return action.payload;
        },
        resetSelectedDrawerCardId: () => {
            return null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetToInitialState, () => {
            return null;
        });
    }
});

export const { setSelectedDrawerCardId, resetSelectedDrawerCardId } =
    selectedDrawerCardIdSlice.actions;

export const selectSelectedDrawerCardId = (state) => state.selectedDrawerCardId;

export default selectedDrawerCardIdSlice.reducer;
